import { registerCommand } from '../registry';
import type { ScopedSearchCommandDef } from '../types';

/**
 * `/chat <text>` — restrict the existing search pipeline to TalkJS
 * message hits only. Same scoped-search pattern as `/transcript`:
 * the host bridge forces `activeFilter = 'message'` while the regular
 * `messages/messagesSearch.ts` executor does the matching.
 */
const chatCommand: ScopedSearchCommandDef = {
  id: 'chat',
  kind: 'scopedSearch',
  scopedFilter: 'message',
  title: 'Search chat messages',
  description: 'Search TalkJS messages tied to active calls.',
  usage: '<text to search>',
};

registerCommand(chatCommand);

export default chatCommand;
